<div *ngIf="tags.length" class="tag-list">
  <div class="tag-list-title">{{ 'SHARED.Tags' | translate }}:</div>
  <div *ngFor="let tag of tags" class="tag-item">
    <span (click)="removeTag(tag.id)" *ngIf="removalHandler" class="remove-icon">×</span>
    <span class="tag-value">{{ tag.title }}</span>
  </div>
</div>
